__turbopack_context__.v({
  "active": "language-list-module-scss-module__0QnoqW__active",
  "language": "language-list-module-scss-module__0QnoqW__language",
  "languageLink": "language-list-module-scss-module__0QnoqW__languageLink",
  "languageList": "language-list-module-scss-module__0QnoqW__languageList",
});
